'use client'

import { BUTTON_INSPIRATIONAL_VARIANT } from '@fukku/button/Inspirational/constants'
import textActionM from '@fukku/styles/texts/textActionM.module.css'
import cx from 'classix'
import { applyStylesIf } from 'utils/applyStylesIf/applyStylesIf'
import { ClientLink, type ClientLinkProps } from 'utils/link/client/ClientLink'
import stylesBase from '../LineAnimatedBase.module.css'
import styles from './LineAnimatedLink.module.css'

type ClientLineAnimatedLinkProps = ClientLinkProps & {
	readonly variant?: BUTTON_INSPIRATIONAL_VARIANT
	readonly active?: boolean
	readonly isTopBar?: boolean
}

export function LineAnimatedLink(
	props: ClientLineAnimatedLinkProps
): React.ReactNode {
	const {
		children,
		active,
		variant = BUTTON_INSPIRATIONAL_VARIANT.DEFAULT,
		className,
		isTopBar = false,
		...rest
	} = props

	return (
		<ClientLink
			{...rest}
			className={cx(
				className,
				stylesBase[variant],
				styles[variant],
				textActionM.className,
				applyStylesIf(active === true, stylesBase.active),
				applyStylesIf(active === false, stylesBase.unselected),
				applyStylesIf(isTopBar, stylesBase.topBar)
			)}
		>
			<span className={stylesBase.text}>{children}</span>
		</ClientLink>
	)
}
